import { AxiosInstance } from "axios";
import { Basket } from "../types/Basket/Basket";
import { BasketOverlapWarning } from "../types/Basket/BasketOverlapWarning";

export default class BasketService {
  private _endpoint = "Basket";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async GetBasket(): Promise<Basket | null> {
    const response = await this._client.get<Basket>(this._endpoint);
    return response.data;
  }

  public async AddToBasket(id: string): Promise<Basket | null> {
    const response = await this._client.post(`${this._endpoint}/${id}`, null, {
      timeout: 0,
      //@ts-ignore - suppressAlert isn't defined on the Axios Config interface
      suppressAlert: true,
    });

    return response.data;
  }

  public async RemoveFromBasket(id: string): Promise<Basket | null> {
    const response = await this._client.delete<Basket>(
      `${this._endpoint}/${id}`,
    );
    return response.data;
  }

  public async EmptyBasket(): Promise<Basket | null> {
    const response = await this._client.delete<Basket>(this._endpoint);
    return response.data;
  }

  public async ConfirmOrder(): Promise<string> {
    const response = await this._client.post<string>(`${this._endpoint}`);
    return response.data;
  }

  public async ChangeCurrency(code: string): Promise<Basket | null> {
    const response = await this._client.patch<Basket | null>(
      `${this._endpoint}?currencyCode=${code}`,
    );
    return response.data;
  }

  public async GetEULA(): Promise<string | null> {
    return (await this._client.get(`${this._endpoint}/EULA`)).data;
  }

  public async GetOverlapWarnings(): Promise<BasketOverlapWarning[]> {
    const response = await this._client.get<BasketOverlapWarning[]>(
      `${this._endpoint}/OverlapWarnings`,
    );
    return response.data;
  }
}
